@if (isVisible) {
<div
  class="snackbar"
  [ngClass]="{
    'error-snackbar': color === 'red',
    'info-snackbar': color === 'green',
    'snackbar-enter': isVisible
  }"
  role="alert"
  [attr.aria-live]="color === 'red' ? 'assertive' : 'polite'"
  aria-atomic="true"
>
  <div class="message-display">
    <span>{{ message | displayTranslation }}</span>
  </div>
</div>
}
